var AnimationLoader = (function () {
    function AnimationLoader() {
    }
    AnimationLoader.loadAnimations = function (assetMap, loader) {
        return new Promise(function (resolve, reject) {
            assetMap
                .filter(function (_a) {
                var name = _a.name;
                return loader.resources[name] === undefined;
            })
                .forEach(function (_a) {
                var name = _a.name, texture = _a.texture, textures = _a.textures, atlas = _a.atlas, skeleton = _a.skeleton;
                if (textures !== undefined) {
                    var reducer = function (accumulator, current) {
                        accumulator[current] = loader.resources[textures[current]].texture;
                        return accumulator;
                    };
                    var images = Object.keys(textures).reduce(reducer, {});
                    var spineLoaderOptions = { metadata: {
                            images: images,
                            atlasRawData: loader.resources[atlas].data
                        } };
                    loader.add(name, skeleton, spineLoaderOptions);
                }
                else if (texture !== undefined) {
                    var spineLoaderOptions = { metadata: {
                            image: loader.resources[texture].texture,
                            atlasRawData: loader.resources[atlas].data
                        } };
                    loader.add(name, skeleton, spineLoaderOptions);
                }
            });
            loader.onError.add(function (_a, loader, resource) {
                var message = _a.message;
                reject(new Error(message + " - " + resource.url));
            });
            loader.load(function () { return resolve(); });
        });
    };
    return AnimationLoader;
}());
export { AnimationLoader };
//# sourceMappingURL=animation-loader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@arcade-client/asset-manager/dist/esm/animation-loader.js
// module id = null
// module chunks = 